import { ComponentProps } from "react";
import ReactLoadingSkeleton from "react-loading-skeleton";

type Props = ComponentProps<typeof ReactLoadingSkeleton>;

export const Skeleton = (props: Props) => {
  return <ReactLoadingSkeleton {...props} />;
};
